<!--
表单验证组件
v-model 需要验证的数据
rule 验证规则详见 https://github.com/yiminghe/async-validator
-->
<template>
  <form class="validate-containers">
    <slot></slot>
  </form>
</template>

<script>
import Schema from "async-validator";

export default {
  name: "FormValidateComponent",
  props: {
    model: {
      type: Object,
    },
    rules: {
      type: Object,
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        const validator = new Schema(this.rules);
        validator.validate(this.model, (errors) => {
          if (errors) {
            this.$notify.error({
              title: "Error",
              message: errors[0].message,
            });
            return reject(errors.map((e) => e.message));
          }
          return resolve();
        });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.validate-container {
}
</style>
